"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("lodash/debounce"));
//
// components
//
const SearchBar_1 = __importDefault(require("components/Dashboard/SearchBar"));
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
//
// utility
//
const DateFormat_1 = require("components/general/utility/DateFormat");
const RenderLogic_1 = require("components/Dashboard/RenderLogic");
//
// styles
//
const noSearch_webp_1 = __importDefault(require("assets/images/dashboard/noSearch.webp"));
const MalomoButton_1 = require("components/Dashboard/MalomoButton");
const StyledColumnHeader_1 = require("components/Dashboard/Tables/StyledColumnHeader");
const StyledSearchBarContainer_1 = require("components/Dashboard/Tables/StyledSearchBarContainer");
const StyledTable_1 = require("components/Dashboard/Tables/StyledTable");
const StyledTableHeader_1 = require("components/Dashboard/Tables/StyledTableHeader");
const StyledBody_1 = require("components/Dashboard/Tables/StyledBody");
const StyledTableContainer_1 = require("components/Dashboard/Tables/StyledTableContainer");
const StyledTableRow_1 = require("components/Dashboard/Tables/StyledTableRow");
const StyledTableCell_1 = require("components/Dashboard/Tables/StyledTableCell");
const StyledSearchMessageContainer_1 = require("components/Dashboard/Tables/StyledSearchMessageContainer");
const StyledGraphic_1 = require("components/Dashboard/StyledGraphic");
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const StyledGreyText_1 = require("components/Dashboard/StyledGreyText");
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const react_transition_group_1 = require("react-transition-group");
const react_bootstrap_1 = require("react-bootstrap");
const DataTable = (props) => {
    const delayedQuery = (0, react_1.useCallback)(
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    (0, debounce_1.default)((q) => props.onSearch(q), 400, true), []);
    function handleSearch(event) {
        delayedQuery(event.target.value);
    }
    function noRecordsHeader(propType) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        const header = {
            shipment: 'No Search Results'
        }[propType];
        return header || 'No customers found.';
    }
    function renderHeaders(headers) {
        if (props.dataType === 'customer') {
            return (react_1.default.createElement("tr", null,
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[0].toUpperCase(), scope: 'col', width: '33.75%' }, headers[0]),
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[1].toUpperCase(), scope: 'col', width: '31.6%' }, headers[1]),
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[2].toUpperCase(), scope: 'col', width: '24.65%' }, headers[2]),
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { scope: 'col', width: '10%' })));
        }
        if (props.dataType === 'order') {
            return (react_1.default.createElement("tr", null,
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[0].toUpperCase(), scope: 'col', width: '21%' }, headers[0]),
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[1].toUpperCase(), scope: 'col', width: '23%' }, headers[1]),
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[2].toUpperCase(), scope: 'col', width: '24%' }, headers[2]),
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[3].toUpperCase(), scope: 'col', width: '16%' }, headers[3]),
                react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { scope: 'col', width: '11%' })));
        }
        return (react_1.default.createElement("tr", null,
            react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[0].toUpperCase(), scope: 'col', width: '14%' }, headers[0]),
            react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[1].toUpperCase(), scope: 'col', width: '27%' }, headers[1]),
            react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[2].toUpperCase(), scope: 'col', width: '15%' }, headers[2]),
            react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[3].toUpperCase(), scope: 'col', width: '18%' }, headers[3]),
            react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { key: headers[4].toUpperCase(), scope: 'col', width: '15%' }, headers[4]),
            react_1.default.createElement(StyledColumnHeader_1.StyledColumnHeader, { scope: 'col', width: '11%' })));
    }
    function renderOrderCell(headers, row, index) {
        if (headers[index] === 'Order') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `number${index}`, width: '21%' }, row.number));
        }
        if (headers[index] === 'Name') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `name${index}`, width: '23%' }, row.customer && row.customer.firstName && row.customer.lastName
                ? `${row.customer.firstName} ${row.customer.lastName}`
                : '─'));
        }
        if (headers[index] === 'Email') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `email${index}`, width: '24%' }, row.customer && row.customer.email ? row.customer.email : '─'));
        }
        if (headers[index] === 'Date') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `date${index}`, width: '16%' }, (0, DateFormat_1.twoDigitDateFormat)(row.insertedAt)));
        }
        return 'default';
    }
    function renderCustomerCell(headers, row, index) {
        if (headers[index] === 'Name') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `name${index}`, width: '34%' }, row.firstName && row.lastName
                ? `${row.firstName} ${row.lastName}`
                : '─'));
        }
        if (headers[index] === 'Email') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `email${index}`, width: '32%' }, row.email));
        }
        if (headers[index] === 'Added On') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `date${index}`, width: '24%' }, (0, DateFormat_1.twoDigitDateFormat)(row.insertedAt)));
        }
        return 'default';
    }
    // eslint-disable-next-line complexity
    function renderShipmentCell(headers, row, index) {
        if (headers[index] === 'Order') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `number${index}`, width: '14%' }, row.order.number ? row.order.number : '—'));
        }
        if (headers[index] === 'Tracking Code') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `tracking${index}`, width: '27%' }, row.trackingCode ? (0, RenderLogic_1.renderTracking)(row) : '—'));
        }
        if (headers[index] === 'Carrier') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `carrier${index}`, width: '15%' }, row.carrierName ? row.carrierName : '—'));
        }
        if (headers[index] === 'Delivery Date') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `delivery${index}`, width: '18%' }, row.deliveredAt ? (0, DateFormat_1.shortDateFormat)(row.deliveredAt) : '—'));
        }
        if (headers[index] === 'Arrival') {
            return (react_1.default.createElement(StyledTableCell_1.StyledTableCell, { className: 'text-cell', key: `arrival${index}`, width: '15%' }, row.arrival ? (0, RenderLogic_1.renderArrival)(row.arrival) : '—'));
        }
        return 'default';
    }
    function renderData(data) {
        const { headers } = props;
        let rowNum = 0;
        const dataMap = data.map((row) => {
            const rowArray = [];
            function handleClick() {
                props.onPressButton(row);
            }
            for (let i = 0; i < headers.length; i++) {
                if (props.dataType === 'order') {
                    rowArray.push(renderOrderCell(headers, row.node, i));
                }
                if (props.dataType === 'customer') {
                    rowArray.push(renderCustomerCell(headers, row.node, i));
                }
                if (props.dataType === 'shipment') {
                    rowArray.push(renderShipmentCell(headers, row.node, i));
                }
            }
            return (react_1.default.createElement(react_transition_group_1.CSSTransition, { classNames: 'fade-fast', in: true, key: rowNum++, timeout: 200 },
                react_1.default.createElement(StyledTableRow_1.StyledTableRow, null,
                    rowArray,
                    react_1.default.createElement(StyledTableCell_1.StyledTableCell, { padding: '16px 16px 16px  0', width: '11%' },
                        react_1.default.createElement(MalomoButton_1.MalomoButton, { className: 'details-button', onClick: handleClick, secondary: true, subtle: true }, props.button)))));
        });
        return (react_1.default.createElement(StyledBody_1.StyledBody, null,
            react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null }, dataMap)));
    }
    if (props.loading) {
        return (react_1.default.createElement(StyledTableContainer_1.StyledTableContainer, null,
            react_1.default.createElement(StyledSearchBarContainer_1.StyledSearchBarContainer, null,
                react_1.default.createElement(SearchBar_1.default, { onSearch: handleSearch })),
            react_1.default.createElement(StyledSearchMessageContainer_1.StyledSearchMessageContainer, { topPadding: true },
                react_1.default.createElement(LoadingSpinner_1.default, null))));
    }
    if (!props.data.length) {
        return (react_1.default.createElement(StyledTableContainer_1.StyledTableContainer, null,
            react_1.default.createElement(StyledSearchBarContainer_1.StyledSearchBarContainer, null,
                react_1.default.createElement(SearchBar_1.default, { onSearch: handleSearch })),
            react_1.default.createElement(react_bootstrap_1.Fade, { appear: true, in: true },
                react_1.default.createElement(StyledSearchMessageContainer_1.StyledSearchMessageContainer, null,
                    react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, { height: '315px' },
                        react_1.default.createElement(StyledGraphic_1.StyledGraphic, { src: noSearch_webp_1.default }),
                        react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, noRecordsHeader(props.dataType)),
                        react_1.default.createElement(StyledGreyText_1.StyledGreyText, { className: 'no-orders', role: 'paragraph' }, "Try changing the search terms."))))));
    }
    return (react_1.default.createElement(StyledTableContainer_1.StyledTableContainer, null,
        react_1.default.createElement(StyledSearchBarContainer_1.StyledSearchBarContainer, null,
            react_1.default.createElement(SearchBar_1.default, { onSearch: handleSearch })),
        react_1.default.createElement(StyledTable_1.StyledTable, { className: 'table table-sm table-nowrap' },
            react_1.default.createElement(StyledTableHeader_1.StyledTableHeader, null, renderHeaders(props.headers)),
            renderData(props.data)),
        react_1.default.createElement("div", { id: 'table-footer' })));
};
exports.default = DataTable;
